<template>
  <div class="sb-filters-panel-radio">
    <SbDropdown
      v-if="dsComponentDetails.version === VersionOptions.LEGACY"
      v-model:value="value"
      :results-limit="6"
      :options="optionsList"
      v-bind="filter.props"
    >
      <template #selection="scope">
        <sb-selected-option>
          <sb-text :value="scope?.selected?.name" />
        </sb-selected-option>
      </template>
      <sb-options>
        <template #default="scope">
          <sb-option :value="scope?.option">
            <sb-text :value="scope?.option?.name" />
          </sb-option>
        </template>
      </sb-options>
    </SbDropdown>
    <sb-select
      v-else
      v-model="value"
      :results-limit="6"
      v-bind="filter.props"
      :options="optionsList"
      option-label="name"
      option-value="key"
      fluid
    />
  </div>
</template>
<script>
import SbText from '@src/components/Text/SbText.vue';
import SbDropdown from '@src/components/Dropdown/SbDropdown.vue';
import SbOption from '@src/components/Dropdown/components/SbOption.vue';
import SbOptions from '@src/components/Dropdown/components/SbOptions.vue';
import SbSelectedOption from '@src/components/Dropdown/components/SbSelectedOption.vue';
import SbSelect from '@src/components/Select/SbSelect.vue';
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';

export default {
  name: 'SbCollapsableCheckbox',
  components: {
    SbDropdown,
    SbOption,
    SbOptions,
    SbSelectedOption,
    SbText,
    SbSelect,
  },
  mixins: [versionedComponentsMixin],
  props: {
    filter: {
      type: Object,
      required: true,
    },
    filterValue: {
      type: Object,
      default: () => { },
    },
  },
  emits: ['update:filter-value'],
  data() {
    return {
      value: null,
    };
  },
  computed: {
    optionsList() {
      return this.filter.options;
    },
  },
  watch: {
    value(newValue) {
      this.$emit('update:filter-value', {
        value: newValue,
      });
    },
  },
  mounted() {
    this.value = this.filterValue?.value;
  },
};
</script>
